<template>
    <div class="relative cursor-pointer">
        <div
            class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
            @click="openFileSelector"
        >
            <PhotographIcon class="h-5 w-5 text-gray-400" />
        </div>
        <div
            class="appearance-none block py-[10px] px-10 sm:text-sm mt-1 border border-gray-300 rounded-md w-full"
            :class="{
                'border-red-500 bg-red-100': hasError,
                'bg-white': ! disabled,
				'bg-gray-200 cursor-not-allowed disabled:opacity-75': disabled,
            }"
            @click="openFileSelector"
        >
            <span v-if="file.name">{{ file.name }}</span>
            <span v-else class="text-gray-400">{{ __('forms::labels.none_selected') }}</span>
        </div>
        <div
            class="absolute inset-y-0 right-0 pr-3 flex items-center"
            @click="reset"
            v-if="file.id && ! disabled"
        >
            <XIcon class="h-5 w-5 text-red-400" />
        </div>
    </div>
</template>

<script>
import eventBus from '@S/eventBus'

import {
    PhotographIcon,
    XIcon,
} from '@heroicons/vue/outline'
import axios from "axios";

export default {
    components: {
        PhotographIcon,
        XIcon,
    },
    props: {
        modelValue: {
            type: [Number, String, null],
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            file: {
                id: null,
                name: null,
                path: null,
            },
        };
    },
    watch: {
        modelValue(newVal, oldVal) {
            this.loadFile();
        },
    },
    mounted() {
        this.loadFile();
        eventBus.$on('file-selected:' + this.name, (file) => {
            this.updateFile(file);
        });
    },
    methods: {
        loadFile() {
            if (! this.modelValue) {
                this.file = {
                    id: null,
                    name: null,
                    path: null,
                };
                return;
            }

            if (this.modelValue === this.file.id) {
                return;
            }

            axios.get(this.$route('admin::files.show', { file: this.modelValue })).then((res) => {
                this.file = res.data;
                this.$emit('file-loaded', res.data);
            });
        },
        openFileSelector() {
            if (this.disabled) {
                return;
            }
            eventBus.$emit('open-file-selector', this.name, this.modelValue);
        },
        updateFile(file) {
            this.file = file;
            this.$emit('update:modelValue', file.id);
        },
        reset() {
            if (this.disabled) {
                return;
            }
            this.file = {
                id: null,
                name: null,
                path: null,
            };
            this.$emit('update:modelValue', null);
        },
    }
}
</script>
